<template>
<div class="container-fluid_">


<spinner v-bind:spinner='spinner'></spinner>
 
<!-- 
<div class="card border-success">
  <div class="card-header bg-success text-white">  
  <h4>
  <i  class="fas fa-list-alt mr-2" aria-hidden="true"></i>  
  LISTA MOVIMENTI </h4></div>

  <div class="card-body ">  
-->

<modal-cost-price @close="stockMovementId=0" v-if="stockMovementId" v-bind:productId="item.productId" v-bind:stockMovementId="stockMovementId"></modal-cost-price>

  <div class="table-wrapper-scroll-y my-custom-scrollbar mt-3 table-responsive">              
  <table class="table table-bordered table-sm table-hover mb-0" id="table">
    <thead >
      <tr class="table-primary">
        <th>
         # 
        </th>  
        <th>
         DATA
        </th>  
        <th>
        ORA
        </th>  
        <th>
          SEDE
        </th>

        <th>
         TIPO
        </th>    
              
        <th class="text-right" >
          TOTALE Q.TA'
        </th> 
        <th>
            COLORE
        </th>

        <th v-for="(col, col_index) in cols" :key="col_index" class="sizes text-center ml-1">
            {{ col }}
        </th>        

        <th>
          NUMERO DOC.
        </th>  
        <th>
          DATA DOC.
        </th>  
        
        <!--
        <th>
          MP  
        </th> 
        -->
     
        

      </tr>
    </thead>
    <tbody>
      <tr :title="item.tipo == 1 ? 'doppio click Prezzo di acquisto e sconto':''" @dblclick="setCostPriceModal(item)" :style="styleObject(item.tipo)" v-for="(item, index) in filteredItems" :key="index">

        <td>
          {{item.stockMovementId}}
        </td>

        <td>
          {{item.create_at}}
        </td>

        <td>
          {{item.time_at}}
        </td>

        <td>
          {{item.store}}
        </td>
        
        <td>
            {{item.typeId}}
            
            <span style="color: black" v-if="item.customer">{{ item.customer  }}</span>
            <span class="ml-2" style="color:black" v-if="item.mp">{{ item.mp  }}</span>
            
            
        </td>
        
        
        <td class="text-right">
            {{item.total_row}}
         </td>
         <td >
          {{item.color}}
        </td>
     
         <td v-for="(col, col_index) in cols" :key="col_index" class="text-right" >
        {{ item[col] }}
        </td>
            
        <td >
          {{item.number}}
        </td>
        <td >
          {{item.date}}
        </td>
      
        
    
        <!--
        <td >
          {{item.mp}}
        </td>
        -->
     
    
      </tr>
    </tbody>
  </table> 
 </div>

  <label for="cerca">
  <i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>  
  <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
  <alert-box  class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
</div>


<!--
</div>
</div>
-->

</template>

<script>
import api                from '@/api';
import { mapGetters }     from 'vuex';
import spinner            from '@/components/common/Spinner.vue';


import alertBox           from '@/components/common/AlertBox.vue';

import modalCostPrice     from '@/components/backOffice/ready/tab/ProductMovementCostPrice.vue'
export default {
   props : ['item'],
   components: {
     spinner,alertBox,modalCostPrice
   
  },
  
  data () {
    return {
    
    alert           : false, 
    msg             :{
      title : ''
    }, 

    items           : [],
    spinner         : false,
    filterKey       : '',
    rows            : [],
    cols            : [], 
    stockMovementId : 0,
    
    
    

    }
  },
  computed: 
  {  
    ...mapGetters(['company','isAdmin']),
    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
      
    
  },
  watch: 
  {
    
  },
      
  mounted()
  {
  

    this.getData()

  },
  created()  
  {

    
  }, 
  methods: 
    {

      setCostPriceModal(item)
      {
        
        
        if(this.isAdmin == 0)
        {
          return
        }
        if(item.tipo != 1)
        {
          return
        }
        this.stockMovementId = item.stockMovementId
        
       
      },
      styleObject :function (typeId)
     {
      let obj = {}
      
      if(typeId == 0)
      {

        obj =  {color:'black',backgroundColor:'silver'}
      }
      if(typeId == 1)
      {

        obj =  {color:'white',backgroundColor:'#800080'}
      }
      if(typeId == 20) 
      {

        obj =  {color:'#006400',backgroundColor:'#F0FFF0'}
      }
      if(typeId == 21 ) 
      {

        obj =  {color:'red'}
      }
      if(typeId == 3 ) 
      {

        obj =  {color:'brown'}
      }
      if(typeId == 4 ) 
      {

        obj =  {color:'purple'}
      }
      if(typeId == 5 ) 
      {
        
        obj =  {color: 'black'}

      }

      
      return obj
     },
      async getData() 
      {
        this.spinner = true  
      
        var data  = {'productId' : this.item.productId}
        var sp = {'sp'           : 'spProductPivot2'}
        
        var json    = Object.assign(data, sp)

        
        await api.post(json).then(res => {
          
        

          if(res.status==200)
            {
               this.items = res.data.recordsets[0]   
               const sizes = this.items[0].sizes
               const cols = sizes.split('|')

               let tmp = []
               
               cols.forEach(e => {
                    tmp.push(e)  
                });          
               this.cols = tmp
              
               

            }
           else if(res.status==500)
           {
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
                
                    
           } 
           else
            {
                            
              
              this.msg.title = 'ATTENZIONE '
              this.msg.title = res
              this.msg.type  = 1
                 
            } 
          

          }).catch(err => {
              
             
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
              
              
          }).finally(() => {
          this.spinner = false
        });


      }
    },
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 600px;
overflow : auto;
}
.table-wrapper-scroll-y {
display  : block;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
a,th{
  font-family : 'Roboto Condensed';
  font-size   : 15px;
 
}
tr{
    cursor         : pointer;
}
input[type='checkbox'] {
 
  cursor         : pointer;
 
}
.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
  
}
.sizes{
    background-color: rgb(25, 202, 25) !important;
    border-color: black;
}
</style>